import React from 'react'
import {Button, Header, Input, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import { createUserLog } from '../../lib/api';
import {useSelector} from "react-redux";

const PPOperationMacroPSM2 =({title, channel, description, option, data, HP, isOperationModeCopied, setIsOperationModeCopied, parentcallback}) => {

    const [open,setOpen]= React.useState(false);
    const [firstOpen, setFirstOpen] = React.useState(false);
    const [secondOpen, setSecondOpen] = React.useState(false);
    const [thirdOpen, setThirdOpen] = React.useState(false);
    const [pwdisp, setPwdisp]= React.useState('');
    const [pwfac, setPwfact]= React.useState('');
    const [pwfmsg, setPwfmsg]= React.useState('');
    const [opdata, setOPdata]= React.useState('');
    const [radioopdata, setRadioOpData] = React.useState([]);
    const [pwdispflag, setpwdispflag] = React.useState(false);
    const [pwfacflag, setfacflag] = React.useState(false);
    const [pwerror, setpwerror] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    // [UPDATE] FR1.7 System tema requirements 260318
    const [idcKeyIn, setIdcKeyIn] = React.useState('');
    let powfactor, powdispatch, idckeyinvalue;

    React.useEffect(() => {
        if(typeof data !== 'undefined' && data.length !== 0 && !isOperationModeCopied){
            if(!isOperationModeCopied){
                radioopdata.length = 0;
            }
            if(radioopdata.length === 0 && !isOperationModeCopied){
                radioopdata.push({'tag_id': 13511,'name': 'PSM2_OPERIN_IDLE', 'tag_value': data[13511]});
                radioopdata.push({'tag_id': 13514,'name': 'PSM2_OPERIN_LOADSHARE', 'tag_value': data[13514]});
                radioopdata.push({'tag_id': 13512, 'name': 'PSM2_OPERIN_GRIDCONNECT', 'tag_value': data[13512]});
                radioopdata.push({'tag_id': 13513, 'name': 'PSM2_OPERIN_GRIDIND', 'tag_value': data[13513]});
                setRadioOpData(radioopdata);
                setIsOperationModeCopied(true);
            }
        }
    }, [data]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handlePPStart =(event, {id}) => {
        event.preventDefault();
        var seqdata =   {'buttonClickType': 'PSM2 PCS FAULTRESET CMD'};
        socket.emit('button click', seqdata);
        setSecondOpen(true);
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ type: "PSM2 PCS FAULTRESET CMD" }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    const handleConf =(event) => {
        event.preventDefault();
        var seqdata =   {'buttonClickType': channel};
        socket.emit('button click', seqdata);
        setOpen(false);
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ type: channel }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    let powFactorLimit = 0.85;
    let powFactorneg = -0.85;
    let powerRating = 60; // update SOFC, change powerRating value by sumin, 240320
    
    const handleModal = () => {
        setThirdOpen(false);
        setSecondOpen(true);
        setpwdispflag(false);
        setFirstOpen(true);
    }

    const handleModalClose =() => {
        setThirdOpen(false);
        setSecondOpen(false);
        setFirstOpen(false);
    }

    const handleOK = () => {
        powfactor = (typeof pwfac === 'undefined' || pwfac === '') ? data[10684] : pwfac;        // OPERIN_POWFACT
        powdispatch = (typeof pwdisp === 'undefined' || pwdisp === '') ? data[10685] : pwdisp;   // OPERIN_SETPOWER
        idckeyinvalue = (typeof idcKeyIn === 'undefined' || idcKeyIn === '') ? data[37218] : idcKeyIn; // IDC_IN_KEY VALUE
        let dispKWValRaw = powdispatch;
        if(powdispatch < 0.9999 || powdispatch > powerRating){// update SOFC 240513 by sumin, 9.9999 -> 0.9999 bug fix
            setSecondOpen(true);
            setpwdispflag(true);
        }
        if (dispKWValRaw >= 1 && dispKWValRaw <= powerRating) {// update SOFC 240513 by sumin, 10 -> 1 bug fix
            if (dispKWValRaw <= 452) {
                powFactorLimit = 0.85;
                powFactorneg = -0.85;
            } else if (dispKWValRaw <= 453) {
                powFactorLimit = 0.852;
                powFactorneg = -0.852;
            } else if (dispKWValRaw <= 455) {
                powFactorLimit = 0.855;
                powFactorneg = -0.855;
            } else if (dispKWValRaw <= 456) {
                powFactorLimit = 0.857;
                powFactorneg = -0.857;
            } else if (dispKWValRaw <= 457) {
                powFactorLimit = 0.859;
                powFactorneg = -0.859;
            } else if (dispKWValRaw <= 458) {
                powFactorLimit = 0.861;
                powFactorneg = -0.861;
            } else if (dispKWValRaw <= 459) {
                powFactorLimit = 0.863;
                powFactorneg = -0.863;
            } else {
                powFactorLimit = 0.865;
                powFactorneg = -0.865;
            }

            if (pwerror || (powfactor < powFactorLimit && (Math.sign(powfactor) === 1)) ||
                (powfactor > powFactorneg && (Math.sign(powfactor) === -1))) {
                setThirdOpen(true);
                setPwfmsg(powFactorLimit);
                setfacflag(true);
            } else {
                var kwdata = null;
                switch (opdata) {
                    case 13512: // PSM2_OPERIN_GRIDCONNECT
                        kwdata = { // TODO : OPERIN_POWFACT, OPERIN_SETPOWER tag_id 수정 필요 
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 10684, 'tag_value': powfactor},
                                {'tag_id': 10685, 'tag_value': powdispatch},
                                {'tag_id': 37218, 'tag_value' : idckeyinvalue},{
                                    'tag_id': 13511,
                                    'tag_value': 0
                                }, {'tag_id': 13514, 'tag_value': 0}, {'tag_id': 13512, 'tag_value': 1},
                                {'tag_id': 13513, 'tag_value': 0}, {'tag_id': 32001, 'tag_value': 1}] //10329 : AINPCS_STATUSWORD2_OVRFLAG
                        };
                        break;
                    case 13513: // OPERIN_GRIDIN
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 10684, 'tag_value': powfactor},
                                {'tag_id': 10685, 'tag_value': powdispatch},
                                {'tag_id': 37218, 'tag_value' : idckeyinvalue},{
                                    'tag_id': 13511,
                                    'tag_value': 0
                                }, {'tag_id': 13514, 'tag_value': 0}, {'tag_id': 13512, 'tag_value': 0},
                                {'tag_id': 13513, 'tag_value': 1}, {'tag_id': 32001, 'tag_value': 1}]
                        };
                        break;
                    case 13511: // PSM2_OPERIN_IDLE
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 10684, 'tag_value': powfactor},
                                {'tag_id': 10685, 'tag_value': powdispatch},
                                {'tag_id': 37218, 'tag_value' : idckeyinvalue},{
                                    'tag_id': 13511,
                                    'tag_value': 1
                                }, {'tag_id': 13514, 'tag_value': 0}, {'tag_id': 13512, 'tag_value': 0},
                                {'tag_id': 13513, 'tag_value': 0}, {'tag_id': 32001, 'tag_value': 1}]
                        };
                        break;
                    case 13514: // PSM2_OPERIN_LOADSHARE
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 10684, 'tag_value': powfactor},
                                {'tag_id': 10685, 'tag_value': powdispatch},
                                {'tag_id': 37218, 'tag_value' : idckeyinvalue},{
                                    'tag_id': 13511,
                                    'tag_value': 0
                                }, {'tag_id': 13514, 'tag_value': 1}, {'tag_id': 13512, 'tag_value': 0},
                                {'tag_id': 13513, 'tag_value': 0}, {'tag_id': 32001, 'tag_value': 1}]
                        };
                        break;
                    default: 
                        kwdata = {
                            'buttonClickType': 'Operation Mode And Dispatch OK Button',
                            'tags': [{'tag_id': 10684, 'tag_value': powfactor},
                                {'tag_id': 10685, 'tag_value': powdispatch},
                                {'tag_id': 37218, 'tag_value' : idckeyinvalue},{
                                    'tag_id': 13511,
                                    'tag_value': 1
                                }, {'tag_id': 13513, 'tag_value': 0}, {'tag_id': 13512, 'tag_value': 0},
                                {'tag_id': 13514, 'tag_value': 0}, {'tag_id': 32001, 'tag_value': 1}]
                        };
                        break;

                }
                socket.emit('button click', kwdata);
                setSecondOpen(false);
                setFirstOpen(false);
                parentcallback(true);
                if (!electronApp) {
                    let log = {
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: null,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({
                            tag_id: kwdata.tags,
                            type: kwdata.buttonClickType,
                        }),
                    };
                    createUserLog({ log }).catch(console.error);
                }
                setPwdisp('');
                setPwfact('');
                setIdcKeyIn(''); // [UPDATE] FR1.7 System team requirement
            }
        } else {
            setThirdOpen(true);
        }
    }

    const handlePFactChange = (event, value) => {
        event.preventDefault();
        if(event.target.value < 0.85 && (Math.sign(event.target.value) === 1)){
            setPwfact(0.85);
            setpwerror(true);
        }
        else if(event.target.value >1.001 && (Math.sign(event.target.value) === 1)){
            setPwfact(Number(1.0).toFixed(1));
            setpwerror(true);
        }
        else if(event.target.value > -0.85 && (Math.sign(event.target.value) === -1)){
            setPwfact(-0.85);
            setpwerror(true);
        }
        else if(event.target.value <= -0.99999 && (Math.sign(event.target.value) === -1)){
            setPwfact(-0.99999);
            setpwerror(true);
        }
        else {
            setPwfact(event.target.value);
            setpwerror(false);
        }
    }

    const handlePwChange = (event, value) => {
        event.preventDefault();
        setPwdisp(event.target.value);
    }

    // [UPDATE] FR1.7 System team requirements
    const handleIdcKeyInChange = (event, value) => {
        event.preventDefault();
        let numValue = Number(event.target.value);
        setIdcKeyIn(numValue);
    }

    const handleCheck = (event, {id}) => {
        switch(id) {
            case 'IDLE':
                setOPdata(13511);
                setRadioOpData([{'tag_id':13511, 'name': 'PSM2_OPERIN_IDLE', 'tag_value': 1}, {'tag_id':13514, 'name': 'PSM2_OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':13512, 'name': 'PSM2_OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':13513, 'name': 'PSM2_OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'LOADSHARE':
                setOPdata(13514);
                setRadioOpData([{'tag_id':13511, 'name': 'PSM2_OPERIN_IDLE', 'tag_value': 0}, {'tag_id':13514, 'name': 'PSM2_OPERIN_LOADSHARE', 'tag_value': 1}, {'tag_id':13512, 'name': 'PSM2_OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':13513, 'name': 'PSM2_OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'GRIDCONN':
                setOPdata(13512);
                setRadioOpData([{'tag_id':13511, 'name': 'PSM2_OPERIN_IDLE', 'tag_value': 0}, {'tag_id':13514, 'name': 'PSM2_OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':13512, 'name': 'PSM2_OPERIN_GRIDCONNECT', 'tag_value': 1}, {'tag_id':13513, 'name': 'PSM2_OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
            case 'GRIDIND':
                setOPdata(13513);
                setRadioOpData([{'tag_id':13511, 'name': 'PSM2_OPERIN_IDLE', 'tag_value': 0}, {'tag_id':13514, 'name': 'PSM2_OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':13512, 'name': 'PSM2_OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':13513, 'name': 'PSM2_OPERIN_GRIDIND', 'tag_value': 1}]);
                break;
            default:
                setOPdata(13511);
                setRadioOpData([{'tag_id':13511, 'name': 'PSM2_OPERIN_IDLE', 'tag_value': 1}, {'tag_id':13514, 'name': 'PSM2_OPERIN_LOADSHARE', 'tag_value': 0}, {'tag_id':13512, 'name': 'PSM2_OPERIN_GRIDCONNECT', 'tag_value': 0}, {'tag_id':13513, 'name': 'PSM2_OPERIN_GRIDIND', 'tag_value': 0}]);
                break;
        }
    }

    return (
        <div>
            {option === 1 ?
                <>
                    <Button onClick={() => setFirstOpen(true)} color ='blue' width='150px' >{title}</Button>
                    <Modal
                        onClose={() => setFirstOpen(false)}
                        onOpen={() => setFirstOpen(true)}
                        open={firstOpen}
                    >
                        <Modal.Header>START POWERPLANT</Modal.Header>
                        <Modal.Description style={styles.header}>
                            <Header> {description}</Header>
                        </Modal.Description>
                        <Modal.Description>
                            <Header color ='red' style={styles.header1}>RESET PCS PSM2</Header>
                            <Header style={{marginLeft: '15px'}}> Do you wish to Reset PCS Faults (PSM2)?</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id = '1'
                                    content='OK'
                                    onClick={handlePPStart}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id = '2'
                                    content='Cancel'
                                    onClick={() => setFirstOpen(false)}
                            />
                        </Modal.Actions>
                        <Modal
                            onClose={() => setSecondOpen(false)}
                            open={secondOpen}
                            size='small'
                        >
                            <Modal.Header>POWER PLANT SETUP</Modal.Header>
                            <Modal.Description style = {{align: 'left'}}>
                                <Header style={styles.header}> OPERATION MODE</Header>
                            </Modal.Description>
                            <Modal.Content>
                                <Input
                                    type='radio'
                                    id='IDLE'
                                    label='IDLE'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'PSM2_OPERIN_IDLE').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Input
                                    type='radio'
                                    id='LOADSHARE'
                                    disabled
                                    label='LOADSHARE'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'PSM2_OPERIN_LOADSHARE').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Input
                                    type='radio'
                                    id='GRIDCONN'
                                    label='GRID CONNECT'
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'PSM2_OPERIN_GRIDCONNECT').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Input
                                    type='radio'
                                    id='GRIDIND'
                                    label='GRID INDEPENDENT'
                                    disabled
                                    checked={(radioopdata.length > 0) ? radioopdata.find(el => el.name === 'PSM2_OPERIN_GRIDIND').tag_value === 1 : false}
                                    onChange={handleCheck}
                                    style={styles.checkbox}
                                />
                                <Modal.Description style = {{align: 'right'}}>
                                    <Header style={styles.header}> POWER DISPATCH</Header>
                                </Modal.Description>
                                <Modal.Content>
                                    {/** // [UPDATE] FR1.7 System team's requirement 260318 */}
                                    <Modal.Description>
                                        <Header style={styles.subheader}> IDC KEY-IN VALUE</Header>
                                        <form autoComplete='off' style={styles.input}>
                                            <Input focus placeholder={data[37218]}
                                                   name='Input change'
                                                   type='number'
                                                   step ='0.0001'
                                                   size='small'
                                                   min ='0'
                                                   max ='9999'
                                                   onChange={(event, value) => handleIdcKeyInChange(event, value)}
                                                   defaultValue={data[37218]}
                                            />
                                        </form>
                                    </Modal.Description>
                                    <Modal.Description>
                                        <Header style={styles.header}> SET POWER </Header>
                                        <form autoComplete='off' style={styles.input}>
                                            <Input focus placeholder={data[10685]}
                                                   name='Input change'
                                                   type='number'
                                                   step ='0.0001'
                                                   size='small'
                                                   min ='1'
                                                   max ='60'
                                                   onChange={(event, value) => handlePwChange(event, value)}
                                                   defaultValue={data[10685]}
                                            />
                                            {/** //update SOFC, change min/max Value 10~460 to 1~60 */}
                                        </form>
                                    </Modal.Description>
                                    <Modal.Description>
                                        <Header style={styles.header}> SET POWER FACTOR</Header>
                                        <form autoComplete='off' style={styles.input}>
                                            <Input focus placeholder={data[10685]}
                                                   name='Input change'
                                                   type='number'
                                                   step ='0.0001'
                                                   max = '1.0'
                                                   size='small'
                                                   onChange={(event, value) => handlePFactChange(event, value)}
                                                   defaultValue={data[10684] === 1 ? Number(1.0).toFixed(1) : data[10684]}
                                            />
                                        </form>
                                    </Modal.Description>
                                </Modal.Content>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button color={'green'}
                                        size='small'
                                        id='1'
                                        content='OK'
                                        onClick={handleOK}
                                />
                                <Button color={'red'}
                                        size='small'
                                        id='2'
                                        content='Cancel'
                                        onClick={handleModalClose}
                                />
                            </Modal.Actions>
                        </Modal>
                        { pwdispflag ?
                            <Modal
                                onClose={() => setThirdOpen(false)}
                                open={thirdOpen}
                                size='small'
                            >
                                <Modal.Header>OUT OF RANGE</Modal.Header>
                                <Modal.Description>
                                    <Header style={styles.header}> The Acceptable Range for Power Dispatch is
                                        1 to {powerRating}</Header>
                                </Modal.Description>
                                <Modal.Actions>
                                    <Button color={'green'}
                                            size='small'
                                            id='1'
                                            content='OK'
                                            onClick={handleModal}
                                    />
                                    <Button color={'red'}
                                            size='small'
                                            id='2'
                                            content='Cancel'
                                            onClick={handleModalClose}
                                    />
                                </Modal.Actions>
                            </Modal>
                            :
                            <Modal
                                onClose={() => setThirdOpen(false)}
                                open={thirdOpen}
                                size='small'
                            >
                                <Modal.Header>OUT OF RANGE</Modal.Header>
                                <Modal.Description>
                                    <Header style={styles.header}> The Acceptable Range for Power Factor Dispatch is
                                        {'+/-' + pwfmsg} to 1.0</Header>
                                </Modal.Description>
                                <Modal.Actions>
                                    <Button color={'green'}
                                            size='small'
                                            id='1'
                                            content='OK'
                                            onClick={handleModal}
                                    />
                                    <Button color={'red'}
                                            size='small'
                                            id='2'
                                            content='Cancel'
                                            onClick={handleModalClose}
                                    />
                                </Modal.Actions>
                            </Modal>
                        }
                    </Modal>
                </>
                :
                option === 2 ? // 'Start PP', Cannot Start or re-start powerplant from ~ 
                    <Modal trigger={<Button color='blue' style={{marginBottom : '5px'}} >{title} </Button>}
                           style={styles.toggle}
                           open={open}
                           onClose={handleClose}
                           onOpen={handleOpen}>
                        <Modal.Header>START POWERPLANT</Modal.Header>
                        <Modal.Description>
                            <Header style={styles.header}> {description}</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id='1'
                                    content='OK'
                                    onClick={handleClose}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id='2'
                                    content='Cancel'
                                    onClick={handleClose}
                            />
                        </Modal.Actions>
                    </Modal>
                    :
                    <Modal trigger={<Button color='blue' style={{marginBottom : '5px'}}>{title} </Button> /**Clear  */} 
                           style={styles.toggle}
                           open={open}
                           onClose={handleClose}
                           onOpen={handleOpen}>
                        <Modal.Header>Confirmation</Modal.Header>
                        <Modal.Description>
                            <Header style={styles.header}> {description}</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id='1'
                                    content='OK'
                                    onClick={handleConf}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id='2'
                                    content='Cancel'
                                    onClick={handleClose}
                            />
                        </Modal.Actions>
                    </Modal>
            }
        </div>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '500px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px',
        marginBottom: '10px'
    },
    header1: {
        marginTop: '20px',
        marginLeft: '15px'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginRight: '40px',
        marginBottom: '5px'
    }
}

export default PPOperationMacroPSM2;